/**
 * @Description:
 * @Author: huage
 * @Date: 2020/9/17
 */
export default {
    dataAuth: {
        "ruleTemplateName": "Rule template name",
        "ruleName": "Rule name",
        "role": "Role",
        "ruleList": "Rule list",
        "ruleTemplateCode": "Rule Template code",
        "applicationExamples": "Application examples",
        "controlledObject": "Controlled object",
        "state": "State",
        "ruleCoding": "Rule coding",
        "ruleEffectiveType": "Rule effective type",
        "roleOfRulesInEffect": "Role of rules in effect",
        "logicalConfiguration": "Logical configuration",
        "fieldName": "Field name",
        "valueType": "Value type",
        "logicalOperator": "Logical operator",
        "value": "Value",
        "addALine": "Add a line",
        "addGroup": "Add group",
        "deleteGroup": "Delete group",
        "addRule": "Add rule",
        "action": "Action",
        "conditionalConfiguration": "Conditional configuration",
        "select": "Select",
        "functionName": "Function name",
        "code": "Code",
        "name": "Name",

        "message1": "Edit rule success",
        "message2": "Add rule success",
        "message3": "Cannot be empty",
        "message4": "There is no associated table or field set for this field. Please select another value type",
        "message5": "There is no associated table set for this field. Please select another value type",

        "text1": "Select system default",
        "text2": "Selection function",
        "text3": "Select other associated tables",
        "sceneCode": "SceneCode"
      }
};


// WEBPACK FOOTER //
// ./src/config/langs/en_US/dataAuth.js